<div
  cdkDrag
  class="trade-manager-drag resize-able"
  (cdkDragStarted)="dragStart()"
  (cdkDragEnded)="dragEnd()"
  cdkDragBoundary=".exotics-main"
  appResizerHorizontal
  minWidth="640"
  [ngStyle]="{ 'top.px': windowTop, 'left.px': windowLeft }"
>
  <div class="trade-manager-container-content">
    <div class="menu-bar" cdkDragHandle (mousedown)="updateZIndex()">
      <div class="trade-manager-container-content__menu-bar__title">
        Trade Manager
      </div>
      <button class="button-close" (click)="close()"></button>
    </div>

    <div class="trade-manager-container-content__main">
      <ng-container *ngIf="showMenuButtons; else showComponents">
        <div class="trade-manager-modal__container__archive-trades">
          <button
            *ngIf="!allTradesArchived; else allTradesArchivedTmpl"
            type="button"
            class="ui-button ui-button--archive-trades"
            (click)="showMenuButtons = false; showArchiveTrades = true"
            [disabled]="!selectedTrades?.length"
          >
            {{
              selectedTrades?.length || 0
                | i18nPlural
                  : {
                      '=0': 'No trades selected for archiving',
                      '=1': 'Archive selected trade',
                      other: 'Archive selected trades'
                    }
            }}
          </button>

          <ng-template #allTradesArchivedTmpl>
            <span> Selected trades have been archived </span>
          </ng-template>
        </div>

        <div class="trade-manager-modal__container__load-trades">
          <button
            type="button"
            class="ui-button ui-button--load-trades"
            (click)="showLoadTradesVersions = true; showMenuButtons = false"
          >
            Load trade versions
          </button>
        </div>

        <div
          class="trade-manager-modal__container__load-trades"
          *ngIf="allowCancelOrAmend"
        >
          <button
            type="button"
            class="ui-button ui-button--load-trades"
            (click)="openCancelDeal()"
          >
            Cancel deal
            <span *ngIf="state === 'Cancelling'">
              &nbsp;
              <span class="spinner spinner-sm"></span>
            </span>
          </button>
        </div>

        <div
          class="trade-manager-modal__container__load-trades"
          *ngIf="allowCancelOrAmend"
        >
          <button
            type="button"
            class="ui-button ui-button--load-trades"
            (click)="openAmendTrade()"
          >
            Amend trade
          </button>
        </div>

        <ng-container *ngIf="loadingSubAccounts">
          <span class="spinner spinner-sm spinner-inverse"> </span>
        </ng-container>

        <div
          class="trade-manager-modal__container__allocate-selected-trade"
          *ngIf="eligibleAllocations?.length || tradeAllocated"
        >
          <ng-container>
            <button
              type="button"
              class="ui-button ui-button--allocate-selected-trade"
              (click)="openTradeAllocations()"
              [title]="
                selectedTrades?.length !== 1
                  ? 'Please select a single trade'
                  : ''
              "
              [disabled]="selectedTrades?.length !== 1 || tradeAllocated"
            >
              {{
                tradeAllocated
                  ? 'Trade has already been allocated'
                  : 'Allocate selected trade'
              }}
            </button>
          </ng-container>
        </div>
      </ng-container>
    </div>

    <div
      class="trade-manager-modal__container__allocate-selected-trade"
      *ngIf="ineligibleReason != null"
    >
      {{ ineligibleReason }}
    </div>

    <ng-template #showComponents>
      <app-archive-trades
        *ngIf="showArchiveTrades"
        [tradesToArchive]="selectedTrades"
        (returnToMenu)="returnToMenu()"
        (allTradesArchivedOutput)="allTradesArchived = $event"
      ></app-archive-trades>

      <app-load-trade-versions
        *ngIf="showLoadTradesVersions"
        (returnToMenu)="returnToMenu()"
      >
      </app-load-trade-versions>

      <app-allocate-trade
        *ngIf="showAllocations"
        [selectedTrade]="fullTradeForAllocation"
        [eligibleAllocations]="eligibleAllocations"
        [strictAllocations]="strictAllocations"
        [subAccounts]="subAccounts"
        (returnToMenu)="returnToMenu()"
      >
      </app-allocate-trade>
    </ng-template>
  </div>
</div>

<dialog #cancelDealDlg>
  <h4>Cancel deal</h4>
  <p>Cancel all trades with deal reference {{ currentDealReference }}</p>
  <div>
    <form method="dialog">
      <button value="cancel" formmethod="dialog">Abort</button>
      <button (click)="confirmCancelDeal(currentDealReference)">
        Confirm Cancellation
      </button>
    </form>
  </div>
</dialog>

<dialog #amendTradeDlg>
  <h4>Amend trade</h4>
  <p>Amend trade {{ currentTradeId }}</p>
  <div>
    <form method="dialog">
      <button value="cancel" formmethod="dialog">Cancel</button>
      <button (click)="confirmAmendTrade(currentTradeId)">Confirm</button>
    </form>
  </div>
</dialog>
